<script>
import {defineComponent, getCurrentInstance, h, markRaw} from "vue";

function pageBound(template, components, directives) {
    return markRaw(
        defineComponent({
            template,
            components,
            directives,
            setup() {
                const page = getCurrentInstance().root.proxy;
                return new Proxy(
                    {},
                    {
                        get: (_, key) => page[key],
                        set: (_, key, value) => {
                            page[key] = value;
                            return true;
                        },
                        has: (_, key) => key in page,
                        getOwnPropertyDescriptor: (_, key) =>
                            key in page ? {configurable: true, enumerable: true, writable: true, value: page[key]} : undefined,
                    }
                );
            },
        })
    );
}

export default {
    name: "EventV2SessionSection",
    inheritAttrs: false,
    props: {
        html: {type: String, default: null},
    },
    computed: {
        swapped() {
            return this.html ? pageBound(this.html, this.$root.$options.components, this.$root.$options.directives) : null;
        },
    },
    render() {
        if (this.html == null) return this.$slots.default?.();
        return this.swapped ? h(this.swapped) : null;
    },
};
</script>
